<!--
	功能：该组件用于实现下拉列表框
	可提供如下功能, 支持的形态及功能有:
		1.  设置列表框的高度, 在CSelect对象标签的 style 里面设置即可
		2.  设置列表框的条目高度(ctrl.itemHeight)
		3.  设置列表框的背景颜色(ctrl.bgClr)
		4.  设置列表框的没有子条目的条目前是否显示一个空的占位元素(ctrl.expandEmp), 以便于同级元素对齐, 当有多级列表显示时需要
		5.  设置列表框的可见条目数(ctrl.size), 多于条目通过滚动显示
		6.  设置列表框的默认选中数据(defv)
		7.  鼠标移出列表框后, 列表项自动隐藏
		8.  显示文本超过长度后, 自动显示 ...
		9.  onchange响应
		10. 使能列表框(setDisabled)
	组件调用参数:
		参数名                    必要性    值域          说明
		ctrl:{
			disabled              可选      bool          使能列表框
			itemHeight            必须      int           条目的高度
			bgClr                 必须      #xxxxxx       列表框背景色
			bodr                  必须      #xxxxxx       边框颜色
			bodrrad               可选                    边框圆角
			expandEmp             必须      bool          条目前是否显示一个空的占位元素
			size                  必须      int           可见的条目数
			def                   必须      string        默认选中的条目值
			Removefirst           可选      bool          是否去掉数据列表的第一个条目
		}
		data:[{
			itemName              必须      string        条目显示文本
			itemValue             必须      string        条目的值
			subItems              必须      jsonarray     子条目
		}]
	输出的值:
		$emit("input")    可用 v-model 接收参数值
	外部调用方法:
		setDisabled       使能列表框setDisabled(flag)
-->

<template>
	<div :style="{'background':ctrl.bgClr}" style="">
		<div id="idCaptPanel" ref="idCaptPanel" @mouseover="onCaptMouseOver" @mouseout="onCaptMouseOut" @click="onCSClick">
			<div id="idCapt" ref="idCapt" :title="captTitle">{{ captCont }}</div>
			<div id="idCaptArr" ref="idCaptArr"></div>
			<div style="flex:0 0 auto; width:3px;"></div>
		</div>
		<div id="idItemPanel" ref="idItemPanel" @mouseover="onItemMouseOver" @mouseout="onItemMouseOut">
			<!--div id="idListEmp" ref="idListEmp" style="width:100%; height:100%; border:1px solid blue;"></div-->
			<div id="idListPanel" ref="idListPanel" style="overflow-y:auto; border:0px solid red;" :style="{'background':ctrl.bgClr}"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'CSelect',
	props:['value', 'ctrl', 'onchange', 'csData', 'defv', 'zIndex'],
	data () {
		return {
			level: 0,             //用于控制条目前面的层级缩进控制
			captCont:"",          //选中条目的文本
			captTitle:"",         //选择框title
			num: 0,               //条目总数
			myVal: "",            //当前的值
		}
	},
	watch:{
		value(v){
			this.setDefault( this.csData, v );
		},
	},
	mounted: function(){
		if( !this.ctrl.bodr || this.ctrl.bodr=="" ) this.ctrl.bodr = "#444444";
		this.$refs["idCaptPanel"].style["border"] = "1px solid "+this.ctrl.bodr;
		if( this.ctrl.bodrrad ) this.$refs["idCaptPanel"].style["border-radius"] = this.ctrl.bodrrad;

		//let h=this.$refs["idCaptPanel"].offsetHeight;
		//this.$refs["idListEmp"].style["height"] = (h)+"px";
		//this.$refs["idListEmp"].style["margin-top"] = (-h)+"px";

		this.getItemsNum( this.csData );   //计算节点个数
		if( this.ctrl.size < this.num ) this.num = this.ctrl.size;
		this.$refs["idListPanel"].style["height"] = (this.num * this.ctrl.itemHeight)+"px";

		this.loadItems( this.$refs["idListPanel"], this.csData, this.level );

		this.setDefault( this.csData, this.defv );

		if( this.ctrl.disabled ) this.setDisabled( true );

		if( this.ctrl.title ) this.captTitle = this.ctrl.title;

		this.ctrl.self = this;
	},
	computed:{

	},
	methods:{
		setDisabled: function( flag ){
			this.ctrl.disabled = flag;
			if( this.ctrl.disabled )
			{
				this.$refs["idCaptPanel"].style["border"] = "1px solid #b4b4b4";
				this.$refs["idCaptPanel"].style["cursor"] = "default";
				this.$refs["idCapt"].style["color"] = "#b4b4b4";
				this.$refs["idCaptArr"].style["border-top"] = "5px solid #b4b4b4";
			}
			else
			{
				this.$refs["idCaptPanel"].style["border"] = "1px solid "+this.ctrl.bodr;
				this.$refs["idCaptPanel"].style["cursor"] = "pointer";
				this.$refs["idCapt"].style["color"] = "";
				this.$refs["idCaptArr"].style["border-top"] = "5px solid #4a4a4a";
			}
		},
		/* private 设置默认选中项的值 */
		setDefault: function( arr, v ){
			this.captCont = "";
			for( let i=0; i<arr.length; i++ )
			{
				if( this.ctrl.Removefirst && v==this.csData[0].itemValue ) return;

				if( arr[i].itemValue == v )
				{
					this.$emit("input", arr[i].itemValue );
					this.captCont = arr[i].itemName;
					//if( this.onchange ) this.onchange( arr[i].itemValue, this.myVal );   //此处不响应
					this.myVal = arr[i].itemValue;
					return;
				}
				if( 0 < arr[i].subItems.length ) this.setDefault( arr[i].subItems, v );
			}
		},
		/* private 取得列表框的所有条目个数 */
		getItemsNum: function( arr ){
			for( let i=0; i<arr.length; i++ )
			{
				this.num++;
				if( 0 < arr[i].subItems.length ) this.getItemsNum( arr[i].subItems );
			}
			if( this.ctrl.Removefirst ) this.num--;
		},
		/* private 加载条目到列表框中 */
		loadItems: function( parentEle, itemArr, level ){
			for( let i=0; i<itemArr.length; i++ )
			{
				if( level==0 && i==0 && this.ctrl.Removefirst ) continue;

				let itemPanel=document.createElement("div");    //节点 Panel
				parentEle.appendChild( itemPanel );
				let captPanel=document.createElement("div");    //节点的 caption Panel
				captPanel.setAttribute("style", "height:"+this.ctrl.itemHeight+"px; display:flex; text-indent:5px; cursor:pointer; align-items:center;");
				itemPanel.appendChild( captPanel );
				for( let j=0; j<level; j++ ){                   //生成前导空格
					let ele=document.createElement("div");
					ele.setAttribute("style", "flex:0 0 auto; width:12px; height:12px;");
					captPanel.appendChild( ele );
				}
				if( 0 < itemArr[i].subItems.length )            //如果有子节点, 生成展开控制图标
				{
					let ele=document.createElement("div");
					ele.setAttribute("style", "flex:0 0 auto; width:20px; height:20px;");
					ele.onclick=function( ){
						if( itemArr[i].childrenEle.style["display"] == "block" )
						{
							itemArr[i].childrenEle.style["display"] = "none";
							itemArr[i].expandIcon.style["background"] = "url(../../static/images/dir_close.png)";
						}
						else
						{
							itemArr[i].childrenEle.style["display"] = "block";
							itemArr[i].expandIcon.style["background"] = "url(../../static/images/dir_open.png)";
						}
					};
					captPanel.appendChild( ele );
					itemArr[i].expandIcon = ele;
				}
				else
				{
					if( this.ctrl.expandEmp )
					{
						let ele=document.createElement("div");
						ele.setAttribute("style", "flex:0 0 auto; width:20px; height:20px;");
						captPanel.appendChild( ele );
					}
				}
				let captCont=document.createElement("div");     //节点的 caption
				captCont.setAttribute("style", "width:0px; height:"+this.ctrl.itemHeight+"px; flex: 1 0 auto; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;");
				captCont.innerText = itemArr[i].itemName;
				if( itemArr[i].itemTitle ) captCont.setAttribute("title", itemArr[i].itemTitle);
				captPanel.appendChild( captCont );
				if( 0 < itemArr[i].subItems.length )
				{
					let childrenPanel=document.createElement("div");
					childrenPanel.setAttribute("style", "display:block;" );
					itemPanel.appendChild( childrenPanel );
					itemArr[i].childrenEle = childrenPanel;
					this.loadItems( childrenPanel, itemArr[i].subItems, level+1 );
				}
				else
				{
					itemArr[i].childrenEle = null;
				}
				captCont.onmouseover=function(){
					captCont.style["color"] = "var(--clrBG2)";
					captCont.style["background"] = "#f1f1f1";
				};
				captCont.onmouseout=function(){
					captCont.style["color"] = "";
					captCont.style["background"] = "";
				};
				let thisVue=this;
				captCont.onclick=function(){
					thisVue.$emit("input", itemArr[i].itemValue);
					if( thisVue.onchange ) thisVue.onchange( itemArr[i].itemValue, thisVue.myVal );
					thisVue.myVal = itemArr[i].itemValue;
					thisVue.captCont = itemArr[i].itemName;
					thisVue.$refs["idItemPanel"].style["display"] = "none";
				};

				//展开控制
				if( itemArr[i].childrenEle )
				{
					if( itemArr[i].childrenEle.style["display"] == "block" )
					{
						itemArr[i].childrenEle.style["display"] = "none";
						itemArr[i].expandIcon.style["background"] = "url(../../static/images/dir_close.png)";
					}
					else
					{
						itemArr[i].childrenEle.style["display"] = "block";
						itemArr[i].expandIcon.style["background"] = "url(../../static/images/dir_open.png)";
					}
				}
			}
		},
		/* private 鼠标hover效果 */
		onCaptMouseOver: function(){
			if( this.ctrl.disabled ) return;

			this.$refs["idCaptArr"].style["border-top"] = "5px solid var(--clrBG2)";
			this.$refs["idCaptPanel"].style["border"] = "1px solid var(--clrBG2)";
		},
		/* private 鼠标hover效果 */
		onCaptMouseOut: function( e ){
			if( this.ctrl.disabled ) return;

			this.$refs["idCaptArr"].style["border-top"] = "5px solid #4a4a4a";
			this.$refs["idCaptPanel"].style["border"] = "1px solid "+this.ctrl.bodr;

			if( this.onMouseOutHide( this.$refs["idCaptPanel"], e, null, [0, 0, 0, 3] ) &&
			    this.onMouseOutHide( this.$refs["idItemPanel"], e, null, [0, 0, 0, 3] ) )
			{
				this.$refs["idItemPanel"].style["display"] = "none";
			}
		},
		/* private 鼠标hover效果 */
		onItemMouseOver: function(){
			if( this.ctrl.disabled ) return;

			this.$refs["idCaptPanel"].style["border"] = "1px solid var(--clrBG2)";
			this.$refs["idCaptArr"].style["border-top"] = "5px solid var(--clrBG2)";
		},
		/* private 鼠标hover效果 */
		onItemMouseOut: function( e ){
			if( this.ctrl.disabled ) return;

			if( this.onMouseOutHide( this.$refs["idItemPanel"], e ) )
			{
				this.$refs["idCaptPanel"].style["border"] = "1px solid "+this.ctrl.bodr;
				this.$refs["idCaptArr"].style["border-top"] = "5px solid #4a4a4a";
				this.$refs["idItemPanel"].style["display"] = "none";
				//this.$refs["idItemPanel"].parentNode.style["z-index"] = 998;
			}
		},
		/* private 鼠标点击显示条目列表 */
		onCSClick: function(){
			if( this.ctrl.disabled ) return;

			let expand=this.$refs["idItemPanel"].style["display"];
			if( expand=="block" )
			{
				this.$refs["idItemPanel"].style["display"] = "none";
				//this.$refs["idItemPanel"].parentNode.style["z-index"] = 998;
			}
			else
			{
				this.$refs["idItemPanel"].style["display"] = "block";
				//this.$refs["idItemPanel"].parentNode.style["z-index"] = 999;
			}
		},
	}
}

</script>

<style scoped>

#idCaptPanel{ width:100%; height:100%; display:flex; flex-direction:row; align-items:center; cursor:pointer; }
#idCapt{ flex:1 0 auto; width:0px; border:0px solid blue; text-indent:5px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }
#idCaptArr{ flex:0 0 auto; width:0; height:0; border-left: 5px solid transparent; border-right: 5px solid transparent; border-top: 5px solid #4a4a4a; }
#idItemPanel{ position:relative; width:100%; background:#ffffff; border:1px solid var(--clrBG2); border-top:0px; display:none; }

</style>



// WEBPACK FOOTER //
// cselect.vue?2015bd86